import { WebStorageStateStore } from "oidc-client-ts";

// The key oidc-client-ts writes the signed-in user under. Exported so the
// cross-tab sync (SessionIdentityGuard) and the no-React token reader
// (tokenUtils) can watch/read the exact same slot.
export const OIDC_USER_STORAGE_KEY = `oidc.user:${process.env.REACT_APP_OIDC_AUTHORITY}:${process.env.REACT_APP_OIDC_CLIENT_ID}`;

const oidcConfig = {
  authority: process.env.REACT_APP_OIDC_AUTHORITY,
  client_id: process.env.REACT_APP_OIDC_CLIENT_ID,
  redirect_uri: `${window.location.origin}${process.env.PUBLIC_URL || ''}/callback`,
  post_logout_redirect_uri: `${window.location.origin}${process.env.PUBLIC_URL || ''}/`,
  scope:
    "openid profile email offline_access urn:zitadel:iam:org:projects:roles",
  response_type: "code",
  automaticSilentRenew: true,
  // SHARED across tabs (localStorage), not per-tab (sessionStorage).
  //
  // sessionStorage is per-tab by spec — it can never be shared, so a second
  // tab opened on the app found no user and started its own signinRedirect,
  // which is what produced the "logged in here, logging in again there"
  // multi-session mess. With one shared slot, tab 2 picks up tab 1's token
  // and `removeUser()` on logout empties it for everyone; each tab watches
  // this key via the `storage` event (see SessionIdentityGuard) to react.
  //
  // Note this is not a new exposure surface: the access token was already
  // mirrored into localStorage by onSigninCallback for the class components.
  //
  // Deliberately NOT shared: `combird_impersonation` stays in sessionStorage
  // so impersonating in one tab never hijacks the admin's other tabs.
  userStore: new WebStorageStateStore({ store: window.localStorage }),
};
/*
Why your aud is still “client id” (and why roles scope alone won’t add project aud)

Your current scope:

openid profile email offline_access urn:zitadel:iam:org:projects:roles

This requests “roles”, but it does not request any audiences.

In ZITADEL, urn:zitadel:iam:org:projects:roles means:

“Give me role claims for projects that are in the audience.”

If you didn’t request any project audiences, there are no customer projects to attach role claims to—so aud stays essentially “the client” (plus whatever ZITADEL adds internally).
*/
export default oidcConfig;
